import {BASE_URL} from "../../config/network";

const getLocationInfo = async ({locationId, force = false}) => {
    const CACHE_KEY = `locationInfo:${locationId}`
    const CACHE_TTL_MS = 5 * 60 * 1000

    const URL = `${BASE_URL}/public/location/info/${locationId}`
    const METHOD = "GET"
    const HEADERS = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }

    console.log("GET Location info")

    if (!force && typeof window !== 'undefined' && window.localStorage) {
        try {
            const cachedRaw = window.localStorage.getItem(CACHE_KEY)
            if (cachedRaw) {
                const cached = JSON.parse(cachedRaw)
                if (cached?.timestamp && Date.now() - cached.timestamp < CACHE_TTL_MS) {
                    return cached.data
                }
            }
        } catch (error) {
            console.warn("GET Location info cache read error", error)
        }
    }

    const response = await fetch(URL, {
        method: METHOD,
        headers: HEADERS
    })

    if (!response.ok) {
        console.log("GET Search address ERROR")
        throw new Error(`HTTP error: ${response.status}`)
    }

    const data = await response.json()

    if (typeof window !== 'undefined' && window.localStorage) {
        try {
            window.localStorage.setItem(
                CACHE_KEY,
                JSON.stringify({timestamp: Date.now(), data})
            )
        } catch (error) {
            console.warn("GET Location info cache write error", error)
        }
    }

    return data
}

export {getLocationInfo}
